<template>
  <div class="form__input">
    <label class="form__label">
      Campus
    </label>
    <div class="main-display" @click="openPopOut">
      <span>
        <label>{{ getValueDisplayName }}</label>
      </span>
      <font-awesome-icon
        :icon="['fas', 'chevron-down']"
        class="icon alt down-arrow"
        aria-hidden="true"
      />
    </div>
    <div v-if="open" v-clickoutside="closePopOut" class="pop-out">
      <div v-for="option in options" :key="option.value" class="selection" @click="emit(option)">
        <div class="checkbox" :class="value === option.value ? 'selected' : ''">
        </div>
        <label>{{ option.display }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import CrisisClient from '@/api/ClinicalOps/CrisisClient';

export default {
  name:'CampusDropDown',
  directives: {
    clickoutside: {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his childrens
          if (!(el == event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
        document.body.addEventListener('touchstart', el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
        document.body.removeEventListener('touchstart', el.clickOutsideEvent);
      },
      stopProp(event) {
        event.stopPropagation();
      }
    }
  },
  props:{
    value: {
      type: Number,
      require: true,
      default: 0
    },
  },
  data() {
    return {
      crisisClient: new CrisisClient(this.$http),
      open: false,
      options: [{ value: 0, display: 'All' }]
    }
  },
  computed: {
    getValueDisplayName() {
      return this.options.find(i => i.value === this.value).display;
    },
  },
  async mounted() {
    await this.loadInstitutions();
  },
  methods: {
    openPopOut() {
      if (!this.open) setTimeout(() => this.open = true)
    },
    closePopOut() {
      this.open = false;
    },
    emit(option) {
      this.$emit('input', option.value !== this.value ? option.value : 0);
    },
    sortInstitutions(institutions) {
      return institutions.sort((a,b) => {
        if (a.display < b.display) {
          return -1;
        }
        if (a.display > b.display) {
          return 1;
        }
        return 0;
      })
    },
    async loadInstitutions() {
      try {
        const response = await this.crisisClient.getCrisisCasesInstitutions();
        const institutions = response.institutions.map((i) => ({ value: i.id, display: i.name }));
        institutions.push({ value: 0, display: 'All' })
        this.options = this.sortInstitutions(institutions);
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style lang="scss">
.selection {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  label {
    margin-left: 5px;
    cursor: pointer;
  }
  .checkbox {
    cursor: pointer;
    display: inline-block;
    border-radius: 5px;
    width: 5px;
    height: 25px;
  }
  .checkbox.selected {
    background-color: $approval-green;
  }
}
.down-arrow {
  margin-left: 7px;
}
.main-display {
  width: 100%;
  background: $textbox-bg-color;
  border: 1px solid $border-color;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  border-radius: 8px;
  padding: 10px;
  margin: 0;
  height: 46px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  text-align: center;
  cursor: pointer;
}
.pop-out {
  width: 100%;
  background: $textbox-bg-color;
  border:  1px solid $border-color;
  border-top: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  position: absolute;
  flex-wrap: nowrap;
  padding: 10px;
  margin-top: -5px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  z-index: 9999;
}
</style>
